export default __webpack_public_path__ + "static/media/dark.32abdf63.png";